import { Component, Input } from '@angular/core';
import { IconService } from 'src/app/shared/services/icon.service';

@Component({
  selector: 'app-student-recent-information-list-view-block-list',
  templateUrl:
    './student-recent-information-list-view-block-list.component.html',
  styleUrls: [
    './student-recent-information-list-view-block-list.component.scss',
  ],
})
export class StudentRecentInformationListViewBlockListComponent {
  constructor(private iconService: IconService) {}
  blockData: any;
  @Input() set data(value: any) {
    if (value) {
      
      this.iconService.addIconToRegistry({
        key: value.blockContent.icon.content.umbracoFile
          ? value.blockContent.icon.content.umbracoFile
          : '',
        path: value.blockContent.icon.content.umbracoFile
          ? value.blockContent.icon.content.umbracoFile
          : '',
      });
      
      this.blockData = value;
    }
  }
}
